import React, { useEffect, useState } from 'react'
import { policies } from '../apis/WebServices';
import Loader from './loader/Loader';
import { sanitize } from '../utils/sanitizeHtml';

const Privacy = () => {
  const [privacy, setPrivacy] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPrivacy = async () => {
    try {
      const response = await policies();
      if (response?.isSuccess) {
        const filter = response?.data?.filter((item) => item?.type === "Privacy Policy");

        setPrivacy(filter);
      }
    } catch (error) {

    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchPrivacy();
  }, [])

  if (loading) {
    return <Loader />
  }
  return (
    <>
      <style>
        {`
          .privacy-content * {
            color: #ffffff !important;
          }
          .privacy-content p,
          .privacy-content span,
          .privacy-content div,
          .privacy-content h1,
          .privacy-content h2,
          .privacy-content h3,
          .privacy-content h4,
          .privacy-content h5,
          .privacy-content h6,
          .privacy-content li,
          .privacy-content ul,
          .privacy-content ol,
          .privacy-content strong,
          .privacy-content em,
          .privacy-content b,
          .privacy-content i {
            color: #ffffff !important;
          }
        `}
      </style>
      <div className='whole-div' style={{ minHeight: "100vh" }}>
        <div className='container-fluid'>
          <div class="page-content">
            <div class="row  dash-nft">
              <div class="col-lg-12">
                <div class="d-flex align-items-center justify-content-between">
                  <h4 class="mb-3 text-white">Privacy Policy</h4>

                </div>

                <div class="term-para">

                  <p className="text-white">

                    <div className='text-white privacy-content' style={{ color: '#ffffff' }} dangerouslySetInnerHTML={{ __html: sanitize(privacy ? privacy[0]?.content : '') }}></div>

                  </p>
                </div>


              </div>

            </div>


          </div>

        </div>

      </div>

    </>
  )
}

export default Privacy
